import { Badge } from '@/components/ui/badge';
import { AlertTriangle, CheckCircle, AlertCircle } from 'lucide-react';

interface ConfidenceIndicatorProps {
  confidence: number;
  showLabel?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export function ConfidenceIndicator({ 
  confidence, 
  showLabel = false,
  size = 'md' 
}: ConfidenceIndicatorProps) {
  const getVariant = () => {
    if (confidence >= 0.85) return 'default';
    if (confidence >= 0.5) return 'secondary';
    return 'destructive';
  };
  
  const getIcon = () => {
    const iconSize = size === 'sm' ? 'h-3 w-3' : size === 'lg' ? 'h-5 w-5' : 'h-4 w-4';
    
    if (confidence >= 0.85) return <CheckCircle className={iconSize} />;
    if (confidence >= 0.5) return <AlertTriangle className={iconSize} />;
    return <AlertCircle className={iconSize} />;
  };
  
  const getLabel = () => {
    if (confidence >= 0.85) return 'High';
    if (confidence >= 0.5) return 'Medium';
    return 'Low';
  };
  
  const variant = getVariant();
  
  return (
    <Badge 
      variant={variant} 
      className={`flex items-center gap-1 ${size === 'sm' ? 'text-xs px-2 py-0.5' : size === 'lg' ? 'text-base px-3 py-1' : 'text-sm px-2 py-1'}`}
    >
      {getIcon()}
      {showLabel && <span>{getLabel()}</span>}
      {!showLabel && <span>{Math.round(confidence * 100)}%</span>}
    </Badge>
  );
}
